import { render, staticRenderFns } from "./NotRememberOldPassword.vue?vue&type=template&id=56b39904&"
import script from "./NotRememberOldPassword.vue?vue&type=script&lang=js&"
export * from "./NotRememberOldPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports